import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { Section as SectionComponent } from './AboutStudySlice';

import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';
import {
  Label,
  Title,
  Description,
} from '@/src/views/GlobalBenefitsReport/slices/BenefitsOverviewSlice';

export const Section = styled(SectionComponent)`
  ${fluidProp('padding-bottom', '20px', '81px')}
  text-align: center;

  ${Title} {
    color: var(--secondaryColor);
    max-width: 771px;
    margin: 0 auto;
    padding: 32px 0 20px;
  }

  ${Label} {
    color: var(--primaryColor);
  }
`;

export const DescriptionWrapper = styled(Description)`
  max-width: 773px;
  margin: 0 auto;
  color: var(--primaryColor);

  strong {
    font-weight: 500;
  }
`;

export const Note = styled(DescriptionWrapper)`
  font-size: 16px;
  line-height: 1.5;
  margin-top: 70px;
`;

const ImageWrapper = styled.div`
  margin-top: 68px;
`;

export function MapSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, title, description, illustration, note } = primary;

  return (
    <Section>
      <ContentContainer>
        {fieldHasContent(label) && <Label>{label}</Label>}
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(description) && (
          <DescriptionWrapper>
            <PrismicRichText field={description} />
          </DescriptionWrapper>
        )}
      </ContentContainer>
      {illustration && (
        <ImageWrapper>
          <Image
            src={illustration?.url}
            alt={illustration?.alt || ''}
            width={illustration?.dimensions.width}
            height={illustration?.dimensions.height}
            quality="100"
          />
        </ImageWrapper>
      )}
      {fieldHasContent(note) && (
        <Note>
          <PrismicRichText field={note} />
        </Note>
      )}
    </Section>
  );
}
